import { render, staticRenderFns } from "./post-publish.vue?vue&type=template&id=4abcc3e1&scoped=true"
import script from "./post-publish.vue?vue&type=script&lang=js"
export * from "./post-publish.vue?vue&type=script&lang=js"
import style0 from "./post-publish.vue?vue&type=style&index=0&id=4abcc3e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abcc3e1",
  null
  
)

export default component.exports